import Vue from 'vue'
import VueI18n from 'vue-i18n'

import cs from './lang/cs'
import en from './lang/en'
import de from './lang/de'

Vue.use(VueI18n)

let currentLocale = document.getElementsByTagName('html')[0].getAttribute('lang')

export default new VueI18n({
    locale: currentLocale,
    fallbackLocale: 'en',
    messages: {
        cs, en, de
    },
    // pluralizationRules for czech language
    pluralizationRules: {
        /**
         * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
         * @param choicesLength {number} an overall amount of available choices
         * @returns a final choice index to select plural word by
         */
        'cs': function (choice, choicesLength) {
            if (choice === 0) {
                return 0;
            }
            if (choice === 1) {
                return 1;
            }
            if (choice >= 2 && choice <= 4) {
                return 2;
            }
            return (choicesLength < 4) ? 2 : 3;
        }

    },
})
